import React from 'react'
import PropTypes from 'prop-types'
import IntlContext from './IntlContext'

function IntlProvider({ worldReady, children }) {
  return <IntlContext.Provider value={{ worldReady }}>{children}</IntlContext.Provider>
}

IntlProvider.propTypes = {
  worldReady: PropTypes.object.isRequired,
  children: PropTypes.node.isRequired,
}

export default IntlProvider
